import routerOptions0 from "/tmp/workspace/staging/ghl-membership-frontend-clientportal/node_modules/.pnpm/nuxt@4.5.2_@babel+plugin-syntax-jsx@7.27.1_@babel+core@7.29.0__@babel+plugin-syntax-typ_1e8bacdd50e1c690d0007fe749c638ef/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}